import { render, staticRenderFns } from "./indexA.vue?vue&type=template&id=525150a8&scoped=true&"
import script from "./indexA.vue?vue&type=script&lang=js&"
export * from "./indexA.vue?vue&type=script&lang=js&"
import style0 from "./indexA.vue?vue&type=style&index=0&id=525150a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525150a8",
  null
  
)

export default component.exports